<template>
    <NuxtLayout name="main">
        <section
            class="bg-[url('https://rdgta.cdn.cyagen.com/rddc/pictures/170619f0-81b4-4176-b986-76f80cb659ab.webp')] bg-no-repeat bg-cover w-[100%] pt-[134px] pb-[114px] max-xl:pt-[72px] max-xl:pb-[76px] max-lg:pt-[88px] max-lg:pb-[92px]">
            <div class="container">
                <div class="text-white text-[56px] leading-[56px] font-bold ax-lg:text-[40px] max-lg:leading-[40px]">{{ $t("Downloads") }}</div>
                <div class="mt-[24px] text-white text-[20px] leading-[36px] max-lg:mt-[16px] max-lg:text-[16px] max-lg:leading-[32px]">
                    {{ $t("DownloadsDesc1") }}
                    <div v-if="i18n.locale.value == 'en'">Rare Disease Database Center</div>
                </div>
            </div>
        </section>
        <section class="container pt-[80px] flex">
            <!-- <div class="w-[304px] max-xl:w-[264px] max-lg:w-[224px]">
                <div class="mb-[26px] text-emphas text-[30px] leading-[42px] font-bold">{{ $t("Filters") }}</div>
                <div
                    v-for="value in filters"
                    class="mb-[8px] last:mb-0 rounded-[4px] px-[24px] leading-[48px] cursor-pointer t-delay-[0.3s] hover:text-white hover:bg-main"
                    :class="filter == value.value ? 'text-white bg-main' : 'bg-[#eeeeee]'">
                    {{ value.label }}
                </div>
            </div> -->
            <div class="flex-1">
                <!-- <div class="mb-[26px] text-emphas text-[30px] leading-[42px] font-bold">{{ $t("Materials") }}</div> -->
                <div class="flex flex-wrap">
                    <div
                        v-for="value in data"
                        class="flex flex-col t-border-uicolor4 rounded-[4px] t-delay-[0.3s] overflow-hidden group hover:bg-[#fbf9ff] hover:t-border-main"
                        :class="css.item">
                        <img class="w-full h-[348px] object-cover max-xl:h-[304px] max-lg:h-[264px]" :src="value.cover" />
                        <div class="pt-[16px] px-[20px] text-emphas leading-[24px] font-bold flex-1">{{ value.name }}</div>
                        <a
                            :href="`${value.url}?attname=${value.name}.pdf&download`"
                            target="_blank"
                            class="pt-[14px] px-[20px] pb-[18px] block text-main leading-[24px] opacity-0 t-delay-[0.3s] group-hover:opacity-100 visited:text-main">
                            <ui-icon name="download" /> {{ $t("DownloadNow") }}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";

//* 插件
const i18n = useI18n();

//* 样式
import css from "./index.module.less";

//* 获取初始数据
const options = await api.server("Downloads", "/api/downloads", { method: "POST" });
const { filters, data } = options.value;

//* 响应式数据
const filter = ref<string>(filters[0].value);
</script>
